import React, { useContext, useEffect, useState, useRef } from 'react'

import { useTheme } from '@emotion/react';
import { FileOpenOutlined, FirstPage, FmdGoodTwoTone, KeyboardArrowLeft, KeyboardArrowRight, LastPage, LocationOn, MoreVertRounded, SearchOffOutlined, SearchOutlined, Edit as EditIcon } from '@mui/icons-material';
import { Button, Checkbox, CircularProgress, IconButton, Input, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import AuthContext from '../../context/AuthContext';

import MapIcon from "../../assets/img/company/location_icon.png";
import CouponIcon from "../../assets/img/company/coupons_icon.png";
import ModalContext from '../../context/ModalContext';
import DrawerContext from '../../context/DrawerContext';
import DescriptionIcon from '@mui/icons-material/Description';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import { useCouponContext } from '../../context/CouponContext';
import CustomButton from '../../common/CustomButton';
import PageSearchBar from '../../common/PageSearchBar';
import { useCouponContextV2 } from '../../context/CouponContextV2';



export default function Coupons() {

  const { editCouponState } = useCouponContext();
  const { editCouponState: editCoupon, clearState: clearCouponState } = useCouponContextV2();

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showMenu, setShowMenu] = useState(null);

  const [companiesData, setCompaniesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayedData, setDisplayedData] = useState([]);
  const [visibleItems, setVisibleItems] = useState(20); // Number of items to show initially
  const tableContainerRef = useRef(null);
  const navigate = useNavigate();

  const [selectedCoupon, setSelectedCoupon] = useState();

  const [filterValue, setFilterValue] = useState('');
  const [searchInput, setSearchInput] = useState('');

  const modalCtx = useContext(ModalContext);

  const drawerCtx = useContext(DrawerContext);

  const authCtx = useContext(AuthContext);

  const handleStatus = (status, validTill=null) => {
    // Check if coupon is expired based on validTill date
    if (validTill) {
      const currentDate = new Date();
      const expiryDate = new Date(validTill);
      if (currentDate > expiryDate) {
        return <div className='status-expired'>Expired</div>;
      }
    }

    //   case 'invite_sent':
    //     return <div className='status-invite'>Invite Sent</div>
    //     break;

    //   default:
    //     break;
    // }
    if (status == "pending") {
      return <div className='status-pending'>Pending</div>;
    } else if (status == "invite_sent") {
      return <div className='status-invite'>Invite Sent</div>;
    } else if (status == "active") {
      return <div className='status-active'>Active</div>;
    } else if (status == "suspended") {
      return <div className='status-suspended'>Suspended</div>;
    } else if (status == "draft") {
      return <div className='status-draft'>Draft</div>;
    } else if (status == "expired") {
      return <div className='status-expired'>Expired</div>;
    } else if (status == "approved") {
      return <div className='status-active'>Approved</div>;
    } else if (status == "archived") {
      return <div className='status-archived'>Archived</div>;
    }
  }



  const getAllCompanies = () => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/companies`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: "Bearer " + authCtx.token }
    })
      .then(response => {
        return response.json();
      }).then(data => {
        if (data.status == 'success') {
          setLoading(false);
          console.log(data?.data, "this is the data");
          setCompaniesData(data?.data);

        }
      }).catch(err => {
        console.error(err)
        // setUpdatingStatus(false)
      });

  }


  useEffect(() => {
    getAllCompanies();
    getAllCategories();
  }, [])


  useEffect(() => {
    if (modalCtx.pageUpdate?.page === "Coupons") {
      modalCtx.setPageUpdate({ page: "" });
      getAllCompanies();
    }
  }, [modalCtx.pageUpdate]);


  const handleModal = (modal, data) => {
    handleClose();
    modalCtx.openModal();
    modalCtx.setDetails(modal, data);
  }

  function toggleDrawerHandler(drawer, user) {
    drawerCtx.openDrawer();
    drawerCtx.setDetails(drawer, user);
  };


  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.target);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };



  useEffect(() => {
    // Filter companies with coupons, apply search filter, and sort alphabetically
    let filteredData = companiesData.filter((data) => {
      // Only show companies that have coupons
      const hasCoupons = data.coupons && data.coupons.length > 0;
      if (!hasCoupons) return false;
      
      // Apply search filter
      const matchesSearch = data.companyDetails.company.toLowerCase().includes(searchInput.toLowerCase()) || 
        (data.companyDetails && data.companyDetails.keywords && data.companyDetails.keywords.toLowerCase().includes(searchInput.toLowerCase()));
      
      return matchesSearch;
    });
    
    // Sort alphabetically by company name
    filteredData.sort((a, b) => {
      const nameA = a.companyDetails?.company?.toLowerCase() || '';
      const nameB = b.companyDetails?.company?.toLowerCase() || '';
      return nameA.localeCompare(nameB);
    });
    
    setDisplayedData(filteredData);
    setVisibleItems(20); // Reset visible items when filter changes
  }, [filterValue, searchInput, loading, companiesData])





  const handleFilterChange = (event) => {
    setFilterValue(event.target.value);
  }

  const [anchorElFilter, setAnchorElFilter] = React.useState(null);
  const open2 = Boolean(anchorElFilter);
  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
  };


  const handleCloseFilter = (value) => {
    setAnchorElFilter(null);

    setFilterValue(value)

  };

  const handleEditCoupon = (company = selectedCompany, coupon = selectedCoupon) => {
    try {
      editCoupon(company, coupon);
      navigate("/create-coupons");
    } catch (e) {
      console.error(e);
    }
  }

  const isEligibleForStatusChange = (status) => {
    return ['pending', 'approved', 'archived'].includes(status);
  }

  const handleStatusChange = (coupon) => {
    if (isEligibleForStatusChange(coupon.status)) {
      handleModal('coupon-status-change', { 
        coupon: coupon, 
        currentStatus: coupon.status 
      });
    }
  }

  const couponCountStyle = (count) => {
    if(count > 0) {
      return "coupon-count coupon-count-more";
    }
    return "coupon-count coupon-count-none";
  }

  // Filter

  //Category
  const [categories, setCategories] = useState([]);
  const getAllCategories = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/categories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + authCtx.token,
        },
      });
  
      const data = await response.json();
      console.log(data);
  
      if (data.status === 'success') {
        setCategories(data?.data);
        console.log(data?.data);
      }
    } catch (err) {
      console.error('Error fetching categories:', err);
    }
  };

  const [filterChips, setFilterChips] = useState([]);

  const openFilterByCategoryModal = async () => {
    handleCloseFilter('status');
    modalCtx.setDetails('filter-coupon-by-category-modal', { 
      handleDisplayedData, 
      data: { categories }
    });
    modalCtx.openModal();
  }
  const handleDisplayedData = (newData) => {

    let filteredData = companiesData.filter(company =>
      company.coupons && company.coupons.length > 0 && company.coupons.some(coupon => newData.includes(coupon.id))
    );

    // Sort alphabetically by company name
    filteredData.sort((a, b) => {
      const nameA = a.companyDetails?.company?.toLowerCase() || '';
      const nameB = b.companyDetails?.company?.toLowerCase() || '';
      return nameA.localeCompare(nameB);
    });

    console.log("Filtered Data:", filteredData);
    setDisplayedData(filteredData);
    setVisibleItems(20); // Reset visible items when filter changes

    let selectedFilter = "Category";

    setFilterChips((prevChips) => {
      if (!prevChips.includes(selectedFilter)) {
        return [...prevChips, selectedFilter]; 
      }
      return prevChips;
    });

  };

  const handleRemoveChip = (chip) => {
    setFilterChips((prevChips) => prevChips.filter((item) => item !== chip));
    console.info(`Removed chip: ${chip}`);
    // Reset to show all companies with coupons, sorted alphabetically
    let filteredData = companiesData.filter((data) => 
      data.coupons && data.coupons.length > 0
    );
    filteredData.sort((a, b) => {
      const nameA = a.companyDetails?.company?.toLowerCase() || '';
      const nameB = b.companyDetails?.company?.toLowerCase() || '';
      return nameA.localeCompare(nameB);
    });
    setDisplayedData(filteredData);
    setVisibleItems(20);
  };

  // Infinite scroll handler
  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (!tableContainer) return;

    const handleScroll = () => {
      const scrollTop = tableContainer.scrollTop;
      const scrollHeight = tableContainer.scrollHeight;
      const clientHeight = tableContainer.clientHeight;

      // Load more when user is near the bottom (within 200px)
      if (scrollTop + clientHeight >= scrollHeight - 200) {
        setVisibleItems((prev) => {
          // Only increase if there are more items to show
          if (prev < displayedData.length) {
            return prev + 20;
          }
          return prev;
        });
      }
    };

    tableContainer.addEventListener('scroll', handleScroll);
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [displayedData.length]);

  return (
    <>
      <div className="coupons-container">
        <div className='header-section'>
          <span className='title'>COUPONS</span>
          <div className='header-items-div'>
            <PageSearchBar value={searchInput} onChange={(e) => setSearchInput(e.target.value)} placeholder="Search" />
            <div className='filter-field'>
              {filterChips.length > 0 && (
                <Stack direction="row" spacing={1} style={{width: '100%'}}>
                  {filterChips.map((chip, index) => (
                    <Chip 
                      key={index} 
                      label={chip} 
                      onDelete={() =>handleRemoveChip(chip)} 
                      style={{width: '100%'}}
                    />
                  ))}
                </Stack>
              )}
              <CustomButton onClick={handleClickFilter} className={'deliva-btn-filter'} >
                Filter By
              </CustomButton>
              
                <Menu id="basic-menu" anchorEl={anchorElFilter} open={open2} onClose={() => handleCloseFilter('')}>
                  <MenuItem onClick={() => handleCloseFilter('agent')}>Agent</MenuItem>
                  <MenuItem onClick={() => openFilterByCategoryModal() }>Category</MenuItem>
                </Menu>
            </div>
            <CustomButton onClick={() => { 
              clearCouponState(); 
              navigate('/create-coupons?mode=new'); 
            }}  >+ Add Coupon</CustomButton>
          </div>
        </div>
        <TableContainer 
          component={Paper} 
          className='coupon-table'
          ref={tableContainerRef}
          sx={{ height: '100%', overflow: 'auto' }}
        >

          <Table sx={{ minWidth: 500 }} stickyHeader>

            <TableHead>
              <TableRow className='company-table-head'>
                <TableCell align="left" className='company-head-cell'>&nbsp;</TableCell>
                <TableCell align="left" className='company-head-cell'>Company</TableCell>
                <TableCell align="left" className='company-head-cell'>Deal</TableCell>
                <TableCell align="left" className='company-head-cell'>Description</TableCell>
                <TableCell align="left" className='company-head-cell'>Valid For</TableCell>
                <TableCell align="left" className='company-head-cell'>Locations</TableCell>
                <TableCell align="left" className='company-head-cell'>Status</TableCell>
                <TableCell align="left" className='company-head-cell'></TableCell>
                <TableCell align="right" className='company-head-cell'></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className='company-table-body'>
              {loading ? 
                   <TableRow>
                      <TableCell colSpan={9} align="center" style={{ border: "0px" }}>
                       <CircularProgress size={52} style={{ color: "#e84118",border: "0px" }} />
                    </TableCell>
                  </TableRow>                     
              : displayedData.slice(0, visibleItems).map((data, index) => (

                <>

                  <TableRow key={data.id} className='company-table-row' style={{ backgroundColor: 'white' }}>
                    <TableCell className='company-table-cell' style={{ width: '50px', padding: 0, paddingLeft: '1rem' }} align="left">
                      <img style={{ height: '32px', width: '32px', borderRadius: '100%' }} src={data.logo}></img>
                    </TableCell>
                    <TableCell className='company-table-cell' style={{ width: '150px' }} align="left">{ data.companyDetails.company }</TableCell>
                    <TableCell className='company-table-cell' style={{ width: '150px' }} align="left">
                      <div className={ couponCountStyle(data.coupons.length) }>
                        <img className='coupon-count-img' src={CouponIcon}></img>
                        <span>{data.coupons.length} Coupon{data.coupons.length > 1 && "s"}</span>
                      </div>
                    </TableCell>
                    <TableCell className='company-table-cell' style={{ width: '200px' }} align="left"></TableCell>
                    <TableCell className='company-table-cell' style={{ width: '100px' }} align="left"></TableCell>
                    <TableCell className='company-table-cell' style={{ width: '100px' }} align="left"></TableCell>
                    <TableCell className='company-table-cell' style={{ width: '140px' }} align="left">
                      <div className='status-container'>{handleStatus(data.companyDetails.status)}</div>
                    </TableCell>
                    <TableCell className='company-table-cell' style={{ width: '100px' }} align="left">
                    </TableCell>
                    <TableCell className='company-table-cell' style={{ width: '50px' }} align="left">
                      <div className='icons-container'>
                        <ArrowDropDownIcon
                          style={{ rotate: showMenu == data.id + "hidden" ? '180deg' : '0deg' }} aria-controls={open ? 'fade-menu' : undefined}
                          aria-haspopup="true" null aria-expanded={open ? 'true' : undefined} onClick={(e) => {
                            if (showMenu == data.id + "hidden") {
                              setShowMenu(null);
                            } else {
                              setShowMenu(data.id + "hidden");
                            }
                        }} />
                      </div>
                    </TableCell>
                  </TableRow>

                  {
                    showMenu == data.id + "hidden" ?  <> {
                      data.coupons?.map((item) => <TableRow key={item.id + "hidden"} className='company-table-row hidden' style={{ backgroundColor: '#fafafc'}}>
                        <TableCell className='company-table-cell' style={{ width: '50px', padding: 0, paddingLeft: '1rem' }} align="left">
                          <img style={{ height: '32px', width: '32px', borderRadius: '100%' }} src={data.logo}></img>
                        </TableCell>
                        <TableCell className='company-table-cell' style={{ flex: 1 }} align="left">{/* {data.companyDetails.company} */}</TableCell>
                        <TableCell className='company-table-cell' style={{ width: '150px' }} align="left">
                          <span><strong>
                            {item.dealUnit === 'PER' ? `${item.deal}% OFF` :
                             item.dealUnit === 'FREE' ? `${item.deal} FREE` :
                             item.dealUnit ? `${item.deal} ${item.dealUnit}` :
                             item.title || 'N/A'}
                          </strong><br />
                          </span>
                        </TableCell>
                        <TableCell className='company-table-cell' style={{ width: '200px' }} align="left">{ item.description }</TableCell>
                        <TableCell className='company-table-cell' style={{ width: '100px' }} align="left">
                          {
                            (() => {
                              if (item.validFor === 99999) {
                                return 'No Expiry';
                              }
                              // If validTill exists, calculate days left
                              if (item.validTill) {
                                const daysLeft = Math.ceil((new Date(item.validTill) - new Date()) / (1000 * 60 * 60 * 24));
                                return daysLeft < 0 ? 'Expired' : `${daysLeft} days`;
                              }
                              // For draft coupons, show timeframe or validFor days
                              return item.timeframe || `${item.validFor} days`;
                            })()
                          }
                        </TableCell>
                        <TableCell className='company-table-cell' style={{ width: '100px' }} align="left">                          
                          { item.onlineOnly == "yes" && <div className='couponDiv'>
                            {/* <img className='mapIcon' src={MapIcon}></img> */}
                            <span>Online</span>
                          </div> }
                        </TableCell>
                        <TableCell className='company-table-cell' style={{ width: '140px' }} align="left">
                          <div 
                            className='status-container' 
                            style={{ 
                              cursor: isEligibleForStatusChange(item.status) ? 'pointer' : 'default',
                              opacity: isEligibleForStatusChange(item.status) ? 1 : 0.7
                            }}
                            title={isEligibleForStatusChange(item.status) ? 'Click to change status' : ''}
                            onClick={() => {
                              if (isEligibleForStatusChange(item.status)) {
                                setSelectedCompany(data);
                                setSelectedCoupon(item);
                                handleStatusChange(item);
                              }
                            }}
                          >
                            {handleStatus(item.status, item.validTill)}
                          </div>
                        </TableCell>
                        <TableCell className='company-table-cell' style={{ width: '100px' }} align="left">
                          <div className='edit-icon-container' onClick={() => handleEditCoupon(data, item)}>
                            <EditIcon className="edit-icon" style={{ width: 20, height: 20, color: '#1976d2' }} />
                          </div>
                        </TableCell>
                        <TableCell className='company-table-cell' style={{ width: '50px' }} align="left">
                          <div className='icons-container'>
                            {/* <DescriptionIcon/> */}
                            <MoreVertRounded aria-controls={open ? 'fade-menu' : undefined} aria-haspopup="true" null aria-expanded={open ? 'true' : undefined} onClick={(e) => {
                              setSelectedCompany(data);
                              setSelectedCoupon(item)
                              handleClick(e);
                            }} />
                          </div>
                        </TableCell>
                      </TableRow>)}
                    </> : null }
                  </>
                )
              )}

              {visibleItems < displayedData.length && (
                <TableRow>
                  <TableCell colSpan={9} align="center" style={{ border: "0px", padding: "20px" }}>
                    <CircularProgress size={32} style={{ color: "#e84118" }} />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <Menu
        id={`fade-menu$`}
        MenuListProps={{
          'aria-labelledby': `fade-button`,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={() => handleModal('assign-agent-register', "id")}>Assign to Agent</MenuItem>
        <MenuItem onClick={() => {
          // toggleDrawerHandler('manage-locations', null);

          handleEditCoupon();

          handleClose()
        }}>Edit Coupon</MenuItem>
        <MenuItem onClick={() => {
          toggleDrawerHandler('manage-company', selectedCompany);
          handleClose()
        }}>Preview</MenuItem>
        <MenuItem onClick={() => handleModal('delete-coupon', { coupon: selectedCoupon })}>Delete Coupon</MenuItem>
      </Menu>
    </>
  );
}
